import { JobType, MoneyUnit } from "@/modules/shared/types/enum";
import {
  Category,
  Degree,
  Level,
  PostType,
  Skill,
  SkillSelect,
} from "@/modules/types/metadata/metadata";
import { EmployeeInfo } from "../employee";
import { BusinessInfo } from "../business";

export enum SortByJobField {
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  closeAt = "closeAt",
  totalApplicants = "totalApplicants",
}

export enum FilterJobStatus {
  all = "all",
  active = "active",
  recruited = "recruited",
  expired = "expired",
}

export enum JobStatus {
  active = "active",
  inactive = "inactive",
  deleted = "deleted",
  blocked = "blocked",
}

export interface Job {
  id: string;
  jobStatus: JobStatus;
  closeAt: number;
  createdAt: number;
  businessId: string;
  totalApplicants?: number;
  categoryId: string;
  levelId: string;
  degreeId: string;
  minYearExperience: number;
  maxYearExperience: number;
  minSalary: number;
  maxSalary: number;
  moneyUnit: MoneyUnit;
  isNegotiable: boolean;
  isSalaryVisible: boolean;
  isDraft: boolean;
  isVerified: boolean;
  address: string;
  lat?: number;
  log?: number;
  country?: string;
  city?: string;
  province?: string;
  district?: string;
  ward?: string;
  street?: string;
  jobType: JobType;
  postType: PostType;
  jobTitle: string;
  jobDescription: string;
  jobRequirement: string;
  jobResponsibility: string;
  jobBenefit: string;
  jobNote: string;
  skills: Skill[];
  languageIds?: string[];

  createdBy?: EmployeeInfo;
  updatedBy?: EmployeeInfo;
  companyInfo?: BusinessInfo;
  category?: Category;
  level?: Level;
  degree?: Degree;
}

export interface DraftJob {
  id: string;
  jobTitle: string;
  postType: PostType;
}

export interface JobCreate {
  businessId?: string;
  categoryId?: string;
  levelId?: string;
  degreeId?: string;
  minYearExperience?: number;
  maxYearExperience?: number;
  minSalary?: number;
  maxSalary?: number;
  moneyUnit?: MoneyUnit;
  isNegotiable?: boolean;
  isSalaryVisible?: boolean;
  isDraft?: boolean;
  isVerified?: boolean;
  address?: string;
  lat?: number;
  log?: number;
  country?: string;
  city?: string;
  province?: string;
  district?: string;
  ward?: string;
  street?: string;
  jobType?: JobType;
  postType?: PostType;
  jobTitle?: string;
  jobDescription?: string;
  jobRequirement?: string;
  jobResponsibility?: string;
  jobBenefit?: string;
  jobNote?: string;
  skills?: SkillSelect[];
  languageIds?: string[];
}
